var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.1 17.1L30.9.9c-1.2-1.2-3-1.2-4.2 0s-1.2 3 0 4.2l1.8 1.8L8.1 18l-3-3c-1.2-1.2-3-1.2-4.2 0s-1.2 3 0 4.2l4.5 4.5 7.2 7.2L1.8 42.1 6 46.3l11.1-11.1 12 12c1.5 1.5 3.6.6 4.2 0 1.2-1.2 1.2-3 0-4.2l-3-3 11.1-20.1 1.8 1.8c1.8 1.8 3.6.6 4.2 0 .9-1.3.9-3.4-.3-4.6zM25.5 35.4L12.6 22.5l20.1-11.1 3.9 3.9z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA0OCA0OCIgdmlld0JveD0iMCAwIDQ4IDQ4IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Im00Ny4xIDE3LjEtMTYuMi0xNi4yYy0xLjItMS4yLTMtMS4yLTQuMiAwcy0xLjIgMyAwIDQuMmwxLjggMS44LTIwLjQgMTEuMS0zLTNjLTEuMi0xLjItMy0xLjItNC4yIDBzLTEuMiAzIDAgNC4ybDQuNSA0LjUgNy4yIDcuMi0xMC44IDExLjIgNC4yIDQuMiAxMS4xLTExLjEgMTIgMTJjMS41IDEuNSAzLjYuNiA0LjIgMCAxLjItMS4yIDEuMi0zIDAtNC4ybC0zLTMgMTEuMS0yMC4xIDEuOCAxLjhjMS44IDEuOCAzLjYuNiA0LjIgMCAuOS0xLjMuOS0zLjQtLjMtNC42em0tMjEuNiAxOC4zLTEyLjktMTIuOSAyMC4xLTExLjEgMy45IDMuOXoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPgo=";
export { SvgPin as ReactComponent };